import { render, staticRenderFns } from "./WarningTable.vue?vue&type=template&id=3bb3ae2e&scoped=true&"
import script from "./WarningTable.vue?vue&type=script&lang=js&"
export * from "./WarningTable.vue?vue&type=script&lang=js&"
import style0 from "./WarningTable.vue?vue&type=style&index=0&id=3bb3ae2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb3ae2e",
  null
  
)

export default component.exports